import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { first } from 'rxjs/operators';

import { InstallationsMigrationListQueryParams } from '@vi-iot/client';

import { InstallationsMigrationActions } from './installations-migration.actions';
import { InstallationsMigrationSelectors } from './installations-migration.selectors';

@Injectable({ providedIn: 'root' })
export class InstallationsMigrationStore {
  state$ = this.store.select(InstallationsMigrationSelectors.getState());
  customerNumber$ = this.store.select(InstallationsMigrationSelectors.getCustomerNumber());
  newCustomerNumber$ = this.store.select(InstallationsMigrationSelectors.getNewCustomerNumber());
  customerCompanyName$ = this.store.select(
    InstallationsMigrationSelectors.getCustomerCompanyName()
  );
  newCustomerCompanyName$ = this.store.select(
    InstallationsMigrationSelectors.getNewCustomerCompanyName()
  );
  installationsToMigrate$ = this.store.select(
    InstallationsMigrationSelectors.getInstallationsToMigrate()
  );
  migrationStatus$ = this.store.select(InstallationsMigrationSelectors.getMigrationStatus());
  installationListCursor$ = this.store.select(
    InstallationsMigrationSelectors.getInstallationListCursor()
  );

  constructor(private store: Store) {}

  setCustomerNumber(customerNumber: string): void {
    this.store.dispatch(InstallationsMigrationActions.setCustomerNumber({ customerNumber }));
  }

  setNewCustomerNumber(newCustomerNumber: string): void {
    this.store.dispatch(InstallationsMigrationActions.setNewCustomerNumber({ newCustomerNumber }));
  }

  getCustomerCompanyNames(customerNumber: string, newCustomerNumber: string): void {
    this.store.dispatch(
      InstallationsMigrationActions.getCustomerCompanyNames({
        customerNumber,
        newCustomerNumber,
      })
    );
  }

  setInstallationsToMigrate(installationsToMigrate: string[]): void {
    this.store.dispatch(
      InstallationsMigrationActions.setInstallationsToMigrate({ installationsToMigrate })
    );
  }

  clearCachedInstallations(): void {
    this.store.dispatch(InstallationsMigrationActions.clearCachedInstallations());
  }

  clearLoadedInstallations(): void {
    this.store.dispatch(InstallationsMigrationActions.clearLoadedInstallations());
  }

  clearCachedData(): void {
    this.store.dispatch(InstallationsMigrationActions.clearCachedData());
  }

  listCompanyCustomerInstallations(params: InstallationsMigrationListQueryParams): void {
    this.store.dispatch(InstallationsMigrationActions.listCompanyCustomerInstallations({ params }));
  }

  migrateInstallations(): void {
    this.store
      .select(InstallationsMigrationSelectors.getMigrateInstallationsParams())
      .pipe(first())
      .subscribe((params) =>
        this.store.dispatch(InstallationsMigrationActions.migrateInstallations({ params }))
      );
  }
}
